module.exports = __webpack_public_path__ + "static/media/GlimmerCape.ff8c615b.png";